const colors = {
  dark: "#0a0a0a",
  white: "#FFFFFF",
};

export default colors;
